import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { TaskPriority } from "@recobra/schemas/task";

import { TASK_PRIORITY_CONFIG } from "./task-status-config";

/** Icon + localized text for a task priority, shared by every priority display in the app. */
export const PriorityLabel: FC<{
  priority: TaskPriority;
  className?: string;
}> = ({ priority, className }) => {
  const { icon: Icon, iconClassName } = TASK_PRIORITY_CONFIG[priority];

  return (
    <span className={`inline-flex items-center gap-1 ${className ?? ""}`}>
      <Icon className={`size-4 shrink-0 ${iconClassName}`} />
      {m.task_priority_label({ priority })}
    </span>
  );
};
